import { fork } from 'redux-saga/effects';

import { actions, selectors } from 'domain/surface';
import { listNavigator } from 'sagas/common';
import { filters } from 'filters/surface'

export default function* navigator() {
  yield fork(listNavigator, { modelName: 'Surface', actions, selectors, filters } );
}
